import {ActionIcon, Group} from "@mantine/core";
import {IconArrowBackUp, IconEdit, IconPlus, IconShape, IconTrash} from "@tabler/icons-react";
import {Tooltip} from '../../tooltip/Tooltip/Tooltip'
import {useTranslation} from "react-i18next";

export type PipelineGraphBuilderActionProps = {
  onAddClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onUndoClick?: () => void;
  onFormatClick?: () => void;
};

export const PipelineGraphBuilderActions = (props: PipelineGraphBuilderActionProps) => {
  const {
    onAddClick,
    onEditClick,
    onDeleteClick,
    onUndoClick,
    onFormatClick,
  } = props

  const { t } = useTranslation(["common"])

  return (
    <Group>
      {onAddClick &&
        <Tooltip label={t("common.action.add", "Add")}>
          <ActionIcon variant="filled" onClick={() => onAddClick()}>
            <IconPlus size="1rem"/>
          </ActionIcon>
        </Tooltip>
      }
      {onUndoClick &&
        <Tooltip label={t("common.action.undo", "Undo")}>
          <ActionIcon variant="filled" onClick={() => onUndoClick()}>
            <IconArrowBackUp size="1rem"/>
          </ActionIcon>
        </Tooltip>
      }
      {onEditClick &&
        <Tooltip label={t("common.action.edit", "Edit")}>
          <ActionIcon variant="filled" onClick={() => onEditClick()}>
            <IconEdit size="1rem"/>
          </ActionIcon>
        </Tooltip>
      }
      {onDeleteClick &&
        <Tooltip label={t("common.action.delete", "Delete")}>
          <ActionIcon variant="filled" onClick={() => onDeleteClick()}>
            <IconTrash size="1rem"/>
          </ActionIcon>
        </Tooltip>
      }
      {onFormatClick &&
        <Tooltip label={t("common.action.format", "Format")}>
          <ActionIcon variant="filled" onClick={() => onFormatClick()}>
            <IconShape size="1rem"/>
          </ActionIcon>
        </Tooltip>
      }
    </Group>
  )
}
